<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
    :minimalize="minimalize"
  >
    <BaseInput
      :label="t['dialog-add_edit-labels']['nazvanie']"
      v-model="name"
      :rules="['required', 'max100']"
      prepend-inner-icon="mdi-image-filter-center-focus"
    />
  </TemplateModal>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
export default {
  name: 'WorktDocsWorkAreaModal',
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    create: Boolean,
    minimalize: Boolean,
    clientId: {
      type: [Number, String],
      default: null,
    }
  },
  data: () => ({
    name: '',
  }),
  computed: {
    ...mapGetters('workDocsWorkArea', ['workDocsWorkAreaShow']),
    t() {
      return this.localStorage.translations.pages['setting-work_area']
    },
    text() {
      return {
        button: {
          open: this.minimalize
            ? this.localStorage.translations.pages['common']['buttons']['dobavit']
            : this.t['dialog-add_edit-buttons']['dobavit-zonu-rabot'],
        },
        title: {
          create: this.t['dialog-add_edit']['sozdanie-zony-raboty'],
          edit: this.t['dialog-add_edit']['redaktirovanie-zony-raboty'],
        },
      }
    },
    SettingWorkDocsWorkAreaProject() {
      return this.$route.name === 'SettingWorkDocsWorkAreaProject'
    },
  },
  methods: {
    ...mapActions('workDocsWorkArea', [
      'onWorkDocsWorkAreaShow',
      'onWorkDocsWorkAreaCreate',
      'onWorkDocsWorkAreaGrid',
      'onWorkDocsWorkAreaAll',
      'onWorkDocsWorkAreaUpdate',
      'onWorkDocsWorkAreaGrid_project',
    ]),
    async onOpen() {
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
      if (this.create)
        this.name = ''
      else {
        await this.onWorkDocsWorkAreaShow(this.id)
          .then(() => {
            this.name = this.workDocsWorkAreaShow.name
          })
      }
    },
    onSave() {
      let data = {
        id: !this.create ? this.workDocsWorkAreaShow.id : null,
        name: this.name,
        project_id: this.$route.params.id || this.projectId,
      }
      if (this.create) {
        this.onWorkDocsWorkAreaCreate(data)
          .then((response) => {
            if (response) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'uspeshno-dobavlen'
                      ],
                  IsError: false,
                },

                { root: true },
              )
              if (this.SettingWorkDocsWorkAreaProject) {
                this.onWorkDocsWorkAreaGrid_project({
                  limit: this.$route.query.limit,
                  page: this.$route.query.page,
                  project_id: this.$route.params.id,
                })
              } else {
                this.onWorkDocsWorkAreaAll(this.$route.params.id)
              }

              this.closeModal()
            }
          })
          .catch((err) => {
            console.log(err)
            if (err.response.data.errors) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
            if (err.response.data.name) {
              this.name = ''
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'name_is_already_in_use'
                      ],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      } else {
        this.onWorkDocsWorkAreaUpdate(data)
          .then((response) => {
            if (response) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'izmeneniya-uspeshno-sohraneny'
                      ],
                  IsError: false,
                },

                { root: true },
              )
              this.onWorkDocsWorkAreaGrid_project({
                limit: this.$route.query.limit,
                page: this.$route.query.page,
                project_id: this.$route.params.id,
              })
              this.closeModal()
            }
          })
          .catch((err) => {
            if (err.response.data.errors) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
            if (err.response.data.name) {
              this.name = ''
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'name_is_already_in_use'
                      ],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      }
    },
  },
}
</script>
